import BlockRenderer from "./BlockRenderer";

const CalloutBlock = ({ block }) => {
  const content = block.content;
  return (
    <div className="callout-block">
      <div className="callout-block-title">{content.title}</div>
      {content.blocks?.map((subBlock) => (
        <BlockRenderer
          key={subBlock.type + "-" + Math.random()}
          block={subBlock}
        />
      ))}
    </div>
  );
};

export default CalloutBlock;